const initialState = {
  index: [],
  data: {},
};

const AppointmentStatus = (state = initialState, action) => {
  switch (action.type) {
    case "CONTENT_APPOINTMENT_STATUS_INDEX":
      return { ...state, index: action.payload.index };
    case "CONTENT_APPOINTMENT_STATUS_DATA":
      return { ...state, data: action.payload.data };
    case "CONTENT_APPOINTMENT_STATUS_RESET":
      return initialState;
    default:
      return state;
  }
};

export default AppointmentStatus;
